import React from "react";
import { useFilePickerState } from "../../states";

export const FilePickerInput = () => {
  const { inputRef, onInputChange, isLoading } = useFilePickerState();

  return (
    <input
      type="file"
      accept="image/png|image/jpg|image/jpeg|.pdf"
      multiple={false}
      ref={inputRef}
      onChange={onInputChange}
      disabled={isLoading}
      style={{ display: "none" }}
    />
  );
};
